import { useTranslation } from '../i18n/LanguageContext';
import { useEffect } from 'react';

/**
 * Definit un titre et une meta description propres a chaque page.
 *
 * Sans dependance ni rendu serveur : le hook met simplement a jour le
 * document au montage. Les moteurs qui executent le JavaScript (Google en
 * tete) voient alors un intitule distinct par page, au lieu du titre unique
 * de index.html partage par toutes les routes.
 *
 * A la sortie de la page, le titre par defaut est restaure.
 */
const TITRE_DEFAUT = 'G1Sport — Trouvez votre coach sportif et suivez vos performances';

export function usePageMeta(title: string, description?: string): void {
  const { t } = useTranslation();
  const localizedTitle = t(title);
  const localizedDescription = description ? t(description) : undefined;
  useEffect(() => {
    document.title = localizedTitle;

    let meta: HTMLMetaElement | null = null;
    let ancienneValeur: string | null = null;
    if (localizedDescription) {
      meta = document.querySelector('meta[name="description"]');
      if (meta) {
        ancienneValeur = meta.getAttribute('content');
        meta.setAttribute('content', localizedDescription);
      }
    }

    return () => {
      document.title = TITRE_DEFAUT;
      if (meta && ancienneValeur !== null) meta.setAttribute('content', ancienneValeur);
    };
  }, [localizedTitle, localizedDescription]);
}
